import { Moment } from 'moment-timezone';
import { Option } from 'types/Generics';
import { IntakeFormCustomQuestionAnswer } from 'types/IntakeForm';
import { v4 as uuid } from 'uuid';

export const emptySavePet = (): SavePet => ({
    uuid: uuid(),
    name: '',
    active: true,
    deleted: false,
    type: null,
    size: null,
    breed: null,
    gender: null,
    hairColor: null,
    hairLength: null,
    birthdate: null,
    vaccines: [],
    answers: []
});

export type SavePet = {
    [K in keyof Pet]: K extends 'uuid' ? Pet[K] : Pet[K] | null;
};

export interface Pet {
    id?: number;
    name: string;
    type: PetType;
    size: PetSize;
    breed?: PetBreed;
    gender: PetGender;
    weight?: number;
    hairColor: PetHairColor;
    birthdate: Moment | null;
    hairLength: PetHairLength;
    image?: {
        file?: File;
        src: string;
        removed?: boolean;
    };
    uuid: string;
    active: boolean;
    deleted: boolean;
    vaccines: Array<PetVaccine>;
    answers: Array<IntakeFormCustomQuestionAnswer>;
}

export const PetTypeIds = {
    DOG: 'dogs',
    CAT: 'cats',
    EXOTIC: 'exotics'
};

export type PetTypeId = (typeof PetTypeIds)[keyof typeof PetTypeIds];

export interface PetType {
    id: PetTypeId;
    singular: string;
    plural: string;
}

export type PetSize = Option<string> & {
    minWeight: number | null;
    maxWeight: number | null;
};

export type PetBreed = Option<number>;

export type PetGender = Option<string>;

export type PetHairLength = Option<string>;

export type PetHairColor = Option<string>;

export type PetVaccine = {
    id?: number;
    uuid: string;
    status: string;
    expiration: Moment | undefined;
    type: Option<string>;
    recordUrl: string | undefined;
    recordFileToUpload?: File;
};

export const createEmptyVaccine = (): PetVaccine => ({
    uuid: uuid(),
    status: 'active',
    expiration: undefined,
    recordUrl: undefined,
    recordFileToUpload: undefined,
    type: { id: '', name: '' }
});
